import axios from 'axios';

export async function fetchPaymentHistory() {
  try {
    const response = await axios.get('/api/billing/orders/', {
      withCredentials: true,
    });

    console.log('Payment history:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching payment history:', error);
    return null;
  }
}
